import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { HppdRationale } from "../../../utils/models";
import { TargetGapMeter } from "../../UIToolkit/DataViz/TargetGapMeter/TargetGapMeter";

type Props = { rationale: HppdRationale; dataTestId: string };

/** Scheduled vs needed hours behind an HPPD auto-post, as the numbers stood when it was posted. */
export const RequestOriginHppdMeter: FC<Props> = ({ rationale, dataTestId }) => {
	const { t } = useTranslation();
	const short = rationale.neededHours - rationale.scheduledHours;
	return (
		<TargetGapMeter
			value={rationale.scheduledHours}
			target={rationale.neededHours}
			valueLabel={t("request.origin.meter.scheduled", { hours: rationale.scheduledHours })}
			targetLabel={t("request.origin.meter.needed", { hours: rationale.neededHours })}
			gapLabel={short > 0 ? t("request.origin.meter.short", { hours: short }) : null}
			ariaLabel={t("request.origin.meter.aria", { scheduled: rationale.scheduledHours, needed: rationale.neededHours })}
			dataTestId={dataTestId}
		/>
	);
};
